/**
 * Runtime environment config injected by the API via /__sally-config.js (loaded
 * before the app bundle). Lets one built image run in both QC and prod.
 */
export interface SallyRuntimeConfig {
  env: string;
  firestoreDatabaseId: string;
}

declare global {
  interface Window {
    __SALLY_CONFIG__?: Partial<SallyRuntimeConfig>;
  }
}

export function runtimeConfig(): SallyRuntimeConfig {
  const c = (typeof window !== "undefined" && window.__SALLY_CONFIG__) || {};
  return {
    env: c.env || "prod",
    firestoreDatabaseId: c.firestoreDatabaseId || "(default)",
  };
}

export function isProdEnv(): boolean {
  return runtimeConfig().env === "prod";
}
